import React, { useEffect, useState } from 'react';
import M from 'materialize-css';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Functions from '../../api/Functions';
import { Redirect, Link } from 'react-router-dom';
import CircleLoader from '../loaders/CircleLoader';

const incompleteFieldNames = {
  noAuthUser: 'Profiles without auth user',
  noPhone: 'Profiles without phone',
};

const IncompleteProfiles = (props) => {
  const { auth } = props;
  const [profiles, setProfiles] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    M.AutoInit();
    Functions.getIncompleteProfiles()
      .then(({ data }) => setProfiles(data))
      .catch((e) => M.toast({ html: e.message ? e.message : 'Something went wrong' }))
      .finally(() => setLoading(false));
  }, []);

  const copyIdToClipboard = (id) => {
    navigator.clipboard.writeText(id);
    M.toast({ html: 'ID copied' });
  };

  const ProfilesSection = ({ field }) => {
    return (
      <div className="col l6 m12 s12">
        <h5>{incompleteFieldNames[field]}</h5>
        {loading && <CircleLoader />}
        {profiles[field] ? profiles[field].map((profile) => renderProfile(profile)) : null}
      </div>
    );
  };

  const renderProfile = (profile) => {
    return (
      <div key={profile.id} className="card z-depth-0 project-summary">
        <div className="card-content grey-text text-darken-3">
          <Link to={window.location} onClick={() => copyIdToClipboard(profile.id)}>
            {profile.id}
          </Link>
          <p>Email: {profile.email}</p>
          <p>Sign up Status: {profile.signUpStatus}</p>
        </div>
      </div>
    );
  };

  if (!auth.uid) return <Redirect to="/signin" />;
  return (
    <div className="container">
      <div className="row">
        <ProfilesSection field="noAuthUser" />
        <ProfilesSection field="noPhone" />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(IncompleteProfiles);
